import React, { createContext, useContext, useState } from 'react';

export const AppContext = createContext({});

export const AppProvider = ({ children }) => {
  const [activeView, setActiveView] = useState('view-model');
  const [accordionState, setAccordionState] = useState({});

  const views = [
    { id: 'view-model', label: 'model' },
    { id: 'view-product', label: 'product' },
  ];

  const value = {
    activeView,
    views,
    setActiveView,
    accordionState,
    setAccordionState,
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): any => useContext(AppContext);
